module.exports = __webpack_public_path__ + "2b173e1fb868a2cb9cbdfa7cc75e621d.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/image/ic_notification.svg
// module id = 1161
// module chunks = 0